// Changelog de versiones de la aplicación
// Este archivo contiene la información detallada de cambios por versión

export const CHANGELOG = {
  // Versión actual - se actualiza automáticamente en el build
  "2026-02-14T12:00:00.000Z": {
    version: "v2.5.2",
    date: "14 de Febrero, 2026",
    changes: {
      new: [],
      improved: [
        "✨ Abonos: Indicadores con $0 abono y abono &lt;50% en rojo para mayor visibilidad",
        "✨ Reporte Bancos: Gráfica Recepción por banco con barras más grandes y tooltips con $ y separador de miles",
        "✨ Reporte Bancos: Gráfica Pagos hechos por en vivo con etiquetas verticales bajo cada columna",
        "✨ Protección contra bucle de recarga: Límite de recargas automáticas en producción"
      ],
      fixed: [
        "🐛 Producción: Corregido recargue continuo de la página con guards en index.html y ErrorBoundary"
      ],
      technical: [
        "🔧 Console y logs deshabilitados en producción vía featureFlags y NODE_ENV",
        "🔧 Modal de actualización muestra changelog de v2.5.2 al detectar nueva versión"
      ]
    },
    highlights: [
      "📊 Reporte Bancos: Gráficas mejoradas con etiquetas verticales y tooltips formateados",
      "💳 Abonos: Indicadores con $0 y &lt;50% resaltados en rojo",
      "🔄 Protección contra recargas infinitas en producción",
      "⚡ Console y logs deshabilitados para mejor rendimiento"
    ]
  },
  "2026-02-14T00:00:00.000Z": {
    version: "v2.5.1",
    date: "14 de Febrero, 2026",
    changes: {
      new: [
        "🆕 Reporte de Bancos: Nueva interna con filtros por viaje, en vivo y banco",
        "🆕 Gráficas: Torta por tarjeta, barras por en vivo, evolución por fecha, recepción por banco",
        "🆕 KPIs: Pagos hechos USD/COP, Recepción COP, Conciliación (diferencia recepción − pagos hechos)",
        "🆕 Exportar Excel: Descarga de datos del reporte en formato .xlsx"
      ],
      improved: [],
      fixed: [],
      technical: [
        "🔧 banksReportService: Integración con endpoints /reports/banks/* (summary, by-envivo, by-bank, envivo-payments, order-payments-by-envivo)",
        "🔧 Librería recharts para gráficas interactivas"
      ]
    },
    highlights: [
      "📊 Reporte de Bancos: Análisis de recepción vs pagos hechos con gráficas y tablas",
      "🔍 Filtros: Por viaje, en vivo, banco y rango de fechas",
      "📈 Gráficas: Torta, barras y línea temporal para análisis visual",
      "📥 Exportar a Excel para reportes offline"
    ]
  },
  "2026-01-30T00:00:00.000Z": {
    version: "v2.5.0",
    date: "30 de Enero, 2026",
    changes: {
      new: [
        "🆕 Saldo Viaje anterior: Nueva opción en el selector de bancos para registros de pagos con saldo de viajes anteriores"
      ],
      improved: [
        "✨ Sistema de versionamiento: Modal de actualización con changelog detallado para cada despliegue",
        "✨ Compilación de producción: Console y logs deshabilitados automáticamente (feature flags)"
      ],
      fixed: [],
      technical: [
        "🔧 Placeholders %BUILD_VERSION% y %BUILD_TIMESTAMP% en index.html para inyección durante build",
        "🔧 version.json y version.js actualizados automáticamente en cada compilación"
      ]
    },
    highlights: [
      "💳 Saldo Viaje anterior: Nueva opción para registrar pagos con saldo de viajes previos",
      "🔄 Sistema de versionamiento actualizado: Modal informa de nuevas versiones con changelog",
      "⚡ Producción optimizada: Sin console ni logs para mejor rendimiento"
    ]
  },
  "2025-01-30T00:00:00.000Z": {
    version: "v2.4.9",
    date: "30 de Enero, 2025",
    changes: {
      new: [
        "🆕 Nu Bank Yessica: Nuevo banco agregado a la lista de opciones para registros de pago"
      ],
      improved: [
        "✨ Sistema de versionamiento: Modal de actualización informará a los usuarios cuando haya nueva versión disponible",
        "✨ Compilación de producción: Logs y console deshabilitados automáticamente para optimizar rendimiento"
      ],
      fixed: [],
      technical: [
        "🔧 Actualización del changelog para despliegue de producción",
        "🔧 Inyección correcta de versión en index.html durante el build"
      ]
    },
    highlights: [
      "💳 Nuevo banco: Nu Bank Yessica disponible en el selector de pagos",
      "🔄 Modal de actualización: Los usuarios serán notificados de esta nueva versión",
      "⚡ Producción optimizada: Sin logs de depuración para mejor performance"
    ]
  },
  "2025-12-30T00:00:00.000Z": {
    version: "v2.4.8",
    date: "30 de Diciembre, 2025",
    changes: {
      new: [
        "🆕 Visualización de pagos en módulo de búsqueda: Los pagos ahora se muestran como tarjetas compactas inline en el header de cada acordeón de cliente",
        "🆕 Modal de comprobantes de pago: Visualización segura de imágenes de comprobantes con autenticación mediante token en el header"
      ],
      improved: [
        "✨ Diseño compacto de tarjetas de pago: Tarjetas de 120px con nombre de banco y monto completo con separador de miles",
        "✨ Scroll horizontal para múltiples pagos: Navegación fluida cuando hay varios pagos registrados",
        "✨ Extracción correcta de pagos: Ahora se obtienen desde trips_accounts filtrando por trip_id del grupo",
        "✨ Deduplicación de pagos: Sistema que elimina pagos duplicados cuando hay múltiples envivos del mismo cliente"
      ],
      fixed: [
        "🐛 Corrección de estructura HTML: Eliminados botones anidados moviendo la sección de pagos fuera del botón del acordeón",
        "🐛 Solución de problema de visualización del modal: Modal movido fuera del contenedor principal para correcta visualización con position fixed",
        "🐛 Corrección de CORS en desarrollo: Modal usa fetch con token en header Authorization en lugar de abrir nueva pestaña",
        "🐛 Pagos no se mostraban: Corregida extracción desde trips_accounts[].payments en lugar de row.payments"
      ],
      technical: [
        "🔧 Refactorización de handleViewReceipt para usar fetch con Bearer token",
        "🔧 Conversión de respuesta a blob y creación de URL temporal con URL.createObjectURL",
        "🔧 Reestructuración de layout del modal usando Fragment (<>) para renderizado en raíz",
        "🔧 Implementación de deduplicación con Map usando payment_id como clave",
        "🔧 Formato de montos con toLocaleString('es-CO') para separador de miles colombiano",
        "🔧 Logs de depuración detallados para diagnóstico de carga de imágenes"
      ]
    },
    highlights: [
      "💳 Pagos visibles en búsqueda: Visualización directa de pagos en cada acordeón de cliente",
      "🖼️ Comprobantes seguros: Modal con autenticación Bearer token para imágenes protegidas",
      "🎨 Diseño mejorado: Tarjetas compactas con scroll horizontal para mejor UX"
    ]
  },
  "2025-12-11T00:00:00.000Z": {
    version: "v2.4.7",
    date: "11 de Diciembre, 2025",
    changes: {
      new: [
        "🆕 Sección 'Clientes con Bolsa': Nueva sección en Consolidado que muestra los nombres de usuario y montos de bolsa de abonos de todos los clientes que tienen saldo disponible",
        "🆕 Visualización de comprobantes de pago: Modal integrado para ver imágenes de comprobantes de pago directamente desde el modal de pagos",
        "🆕 Botón de comprobante en modal de pagos: Cada pago ahora muestra un botón para visualizar su comprobante si está disponible"
      ],
      improved: [
        "✨ Visualización de imágenes con autenticación: Las imágenes de comprobantes se cargan usando fetch con token de autenticación para evitar redirecciones",
        "✨ Organización de secciones: La sección 'Clientes con Bolsa' se muestra debajo de 'Seleccionar Viajes' en la misma columna para mejor organización",
        "✨ Ordenamiento de clientes: Los clientes con bolsa se ordenan por monto descendente para fácil identificación",
        "✨ Carga eficiente: La información de bolsas se obtiene de los datos ya consultados, sin consultas adicionales al backend"
      ],
      fixed: [
        "🐛 Redirección al home al abrir comprobantes: Los enlaces a imágenes de comprobantes ahora funcionan correctamente usando autenticación",
        "🐛 Problema de acceso a imágenes protegidas: Las imágenes se cargan mediante fetch con headers de autenticación en lugar de enlaces directos"
      ],
      technical: [
        "🔧 Nuevo useMemo para calcular clientes con bolsa desde consolidatedOrderCards",
        "🔧 Función handleViewReceipt para cargar imágenes con autenticación Bearer token",
        "🔧 Modal de imagen de comprobante con carga asíncrona y manejo de errores",
        "🔧 Gestión de blob URLs para imágenes temporales con limpieza automática de memoria",
        "🔧 Reemplazo de enlaces <a> por botones onClick para mejor control de autenticación"
      ]
    },
    highlights: [
      "💼 Nueva sección: Visualización de clientes con bolsa de abonos",
      "🖼️ Modal de comprobantes: Visualización segura de imágenes de pagos con autenticación",
      "🔒 Seguridad mejorada: Acceso a imágenes protegidas mediante autenticación Bearer token"
    ]
  },
  "2025-12-10T00:00:00.000Z": {
    version: "v2.4.6",
    date: "10 de Diciembre, 2025",
    changes: {
      new: [
        "🆕 Visualización de viajes seleccionados en header: Los nombres de los viajes seleccionados en Consolidado ahora aparecen como badges junto a 'Makana Live Manager' en el menú superior",
        "🆕 Sincronización entre componentes: El header del menú superior se actualiza automáticamente cuando se seleccionan/deseleccionan viajes en Consolidado"
      ],
      improved: [
        "✨ Información contextual en header: Fácil identificación de qué viajes están seleccionados sin necesidad de bajar al contenido",
        "✨ Badges diferenciados: Los viajes seleccionados se muestran con badge indigo para diferenciarlos del en vivo del Dashboard (morado)"
      ],
      fixed: [
        "🐛 Corrección crítica: La bolsa de abonos ya NO se suma al total 'Abonado' en Consolidado - La bolsa es un sobrante de pagos anteriores que aún no se ha aplicado a órdenes",
        "🐛 Mensaje incorrecto en modal de pagos: Ahora se indica claramente que la bolsa NO está incluida en el total abonado"
      ],
      technical: [
        "🔧 Estado consolidadoSelectedTrips en App.jsx para rastrear viajes seleccionados en Consolidado",
        "🔧 Callback onSelectedTripsChange para comunicación entre Consolidado y App.jsx",
        "🔧 useEffect en Consolidado para notificar cambios en selectedTrips automáticamente",
        "🔧 Eliminada suma de totalAdvancePayments al totalPaid en consolidateAccumulatedData",
        "🔧 Actualizado mensaje en PaymentDetailsModal para aclarar que bolsa NO está incluida en abonado"
      ]
    },
    highlights: [
      "💼 Corrección crítica: Bolsa de abonos ya no se suma incorrectamente al total abonado",
      "📍 Visualización de viajes seleccionados en header para mejor contexto",
      "🎯 Información clara en modal de pagos sobre el estado de la bolsa de abonos"
    ]
  },
  "2025-12-09T00:00:00.000Z": {
    version: "v2.4.5",
    date: "9 de Diciembre, 2025",
    changes: {
      new: [],
      improved: [
        "✨ Cálculo preciso de totales: Los totales en Consolidado ahora se calculan directamente desde los items (precio × cantidad) para garantizar precisión",
        "✨ Validación doble de totales: Sistema de recálculo que verifica y corrige totales desde los items individuales",
        "✨ Logs de depuración mejorados: Logs detallados que muestran el desglose completo de items y sus subtotales para facilitar la validación"
      ],
      fixed: [
        "🐛 Total incorrecto en cards de Consolidado - ahora se calcula correctamente sumando items directamente",
        "🐛 Dependencia de order.total_amount del backend causaba totales erróneos - ahora se calcula desde items",
        "🐛 Totales no coincidían con la suma de productos visibles - ahora son precisos y verificables"
      ],
      technical: [
        "🔧 Cálculo de totalAmount por orden desde items: precio × cantidad",
        "🔧 Recálculo final del total consolidado desde todos los items del cliente",
        "🔧 Validación: uso de total recalculado si es mayor a 0, fallback a total acumulado",
        "🔧 Logs de depuración con desglose completo: nombre, precio, cantidad, subtotal por item",
        "🔧 Cálculo de totalRevenue actualizado para usar totales recalculados de las cards"
      ]
    },
    highlights: [
      "💰 Cálculo preciso de totales en Consolidado desde items individuales",
      "✅ Corrección de totales incorrectos que no coincidían con productos visibles",
      "🔍 Logs detallados para validación y depuración de cálculos"
    ]
  },
  "2025-12-05T00:00:00.000Z": {
    version: "v2.4.4",
    date: "5 de Diciembre, 2025",
    changes: {
      new: [
        "🆕 Botón 'Pagos' en Consolidado: Acceso rápido a información de pagos y bolsa de abonos desde las cards consolidadas",
        "🆕 Modal de visualización de pagos: Modal completa que muestra detalles de pagos, bolsa de abonos y resumen del pedido consolidado",
        "🆕 Visualización de bolsa de abonos por cliente: Muestra el saldo disponible en bolsa de abonos agrupado por viaje",
        "🆕 Lista completa de pagos: Visualización de todos los pagos realizados con banco, monto y fecha por cada orden del cliente"
      ],
      improved: [
        "✨ Acceso rápido a información financiera: Botón 'Pagos' junto al botón 'Copiar' para acceso inmediato a información de pagos",
        "✨ Información consolidada: Modal muestra resumen completo del pedido, pagos y bolsa de abonos en un solo lugar",
        "✨ Carga inteligente de datos: Los pagos y bolsas se cargan automáticamente al abrir la modal",
        "✨ Interfaz intuitiva: Modal con scroll independiente, header fijo y secciones bien diferenciadas"
      ],
      fixed: [],
      technical: [
        "🔧 Función handleOpenPaymentModal para gestionar apertura y carga de datos de la modal",
        "🔧 Carga asíncrona de bolsa de abonos por cada viaje único del cliente",
        "🔧 Carga de pagos de todas las órdenes del cliente con eliminación de duplicados",
        "🔧 Estados para gestión de modal: showPaymentModal, selectedCardForPayments, paymentModalData",
        "🔧 Integración de apiService.payment.getByOrder y apiService.advancePayment.getBalance",
        "🔧 Manejo de estados de carga con indicador visual durante obtención de datos"
      ]
    },
    highlights: [
      "💳 Modal de pagos completa en Consolidado con información detallada",
      "💰 Visualización de bolsa de abonos y pagos realizados por cliente",
      "📊 Resumen consolidado de información financiera en un solo lugar"
    ]
  },
  "2025-12-04T23:30:00.000Z": {
    version: "v2.4.3",
    date: "4 de Diciembre, 2025",
    changes: {
      new: [
        "🆕 Ícono de avión en Logística: Indicador visual junto al nombre del producto para identificar productos que viajan en maleta (carry_on)"
      ],
      improved: [
        "✨ Nombres de productos completos: Los nombres de productos en las cards del Dashboard ahora se muestran completos en múltiples líneas sin truncar",
        "✨ Visualización mejorada: Nombres largos de productos se ajustan automáticamente a múltiples líneas con line-height optimizado",
        "✨ Legibilidad mejorada: Los nombres de productos son completamente legibles sin cortes ni truncados"
      ],
      fixed: [
        "🐛 Nombres de productos se cortaban en las cards del Dashboard - ahora se muestran completos",
        "🐛 Productos con nombres largos no eran legibles - ahora se dividen en múltiples líneas"
      ],
      technical: [
        "🔧 Eliminación de clase truncate y límite de 150 caracteres en nombres de productos",
        "🔧 Implementación de word-break y white-space normal para permitir múltiples líneas",
        "🔧 Normalización del campo carry_on en Logística para manejar diferentes formatos (número, string, boolean)",
        "🔧 Logs de depuración agregados para verificar presencia del campo carry_on en datos del backend"
      ]
    },
    highlights: [
      "✈️ Ícono de avión visible en Logística para productos que viajan en maleta",
      "📝 Nombres de productos completos y legibles en todas las cards del Dashboard"
    ]
  },
  "2025-12-04T23:00:00.000Z": {
    version: "v2.4.2",
    date: "4 de Diciembre, 2025",
    changes: {
      new: [],
      improved: [
        "✨ Actualización de estado en tiempo real: El estado de arribo de productos se actualiza inmediatamente en la interfaz sin necesidad de recargar"
      ],
      fixed: [
        "🐛 Estado de arribo no se actualizaba visualmente después de cambiar - ahora se actualiza correctamente tanto en arrival_status como estado_de_arribo",
        "🐛 El dropdown de estado de arribo mostraba el estado anterior después de actualizar - ahora refleja el estado actualizado inmediatamente"
      ],
      technical: [
        "🔧 Corrección en handleUpdateProductStatus: ahora actualiza ambos campos arrival_status y estado_de_arribo simultáneamente",
        "🔧 Logs de depuración agregados para rastrear actualizaciones de estado en tiempo real",
        "🔧 Sincronización mejorada entre el estado del backend y el estado local del frontend"
      ]
    },
    highlights: [
      "🔄 Actualización instantánea de estados de arribo en Logística",
      "✅ Corrección de sincronización entre backend y frontend"
    ]
  },
  "2025-12-03T23:00:00.000Z": {
    version: "v2.4.1",
    date: "3 de Diciembre, 2025",
    changes: {
      new: [
        "🆕 Ocultación inteligente al copiar imagen: La línea 'Abono Mín. (con maleta)' se oculta automáticamente al generar la imagen de la card en Consolidado"
      ],
      improved: [
        "✨ Copia de imagen mejorada: Al copiar la imagen de una card consolidada, se ocultan elementos internos innecesarios para una imagen más limpia",
        "✨ Restauración automática: Los elementos ocultos se restauran automáticamente después de copiar la imagen al portapapeles"
      ],
      fixed: [
        "🐛 Imagen copiada mostraba información de abono mínimo que solo es relevante internamente - ahora se oculta en la imagen compartida"
      ],
      technical: [
        "🔧 Integración de ocultación temporal de elementos con clase 'min-payment-line' en función copyOrderAsImage",
        "🔧 Restauración de visibilidad en callbacks de éxito y error de html2canvas",
        "🔧 Manejo de ocultación tanto en documento original como en clon durante captura de imagen"
      ]
    },
    highlights: [
      "📸 Imágenes más limpias al compartir cards de Consolidado",
      "🎯 Ocultación automática de información interna al copiar imágenes"
    ]
  },
  "2025-12-01T23:00:00.000Z": {
    version: "v2.4.0",
    date: "1 de Diciembre, 2025",
    changes: {
      new: [
        "🆕 Integración de Bolsa de Abonos en Consolidado: Los abonos en bolsa ahora se suman automáticamente al total 'Abonado' en las cards consolidadas",
        "🆕 Cálculo inteligente de bolsas: Suma las bolsas de cada viaje una sola vez, incluso cuando un cliente tiene múltiples en vivos en el mismo viaje",
        "🆕 Porcentaje de pago visible: Indicador de porcentaje pagado debajo de la barra de progreso en todas las cards de Consolidado",
        "🆕 Botón 'Seleccionar Todos' mejorado: Carga secuencial de en vivos con actualización progresiva de indicadores y barras de progreso en tiempo real"
      ],
      improved: [
        "✨ Ampliación de paleta de colores: Sistema de 26 colores distintos para identificar en vivos en Consolidado (antes 20 colores)",
        "✨ Mejor diferenciación visual: Colores más contrastados y bien diferenciados entre en vivos para mejor identificación visual",
        "✨ Carga progresiva: Los indicadores (clientes, órdenes, totales) se actualizan después de cada en vivo durante la carga continua",
        "✨ Logs de depuración mejorados: Sistema de logs detallados para rastrear la obtención de bolsas de abonos y trip_id",
        "✨ Validación de trip_id: Sistema robusto que obtiene trip_id desde múltiples fuentes (orden, envivo, backend)",
        "✨ Asignación automática de tripId: Los en vivos ahora tienen tripId asignado automáticamente al cargarse por viaje"
      ],
      fixed: [
        "🐛 Bolsa de abonos no se sumaba en Consolidado - ahora se integra correctamente en el cálculo de 'Abonado'",
        "🐛 Porcentaje de pago no se mostraba en cards de Consolidado - ahora visible debajo de cada barra de progreso",
        "🐛 Colores de en vivos se repetían al tener más de 20 en vivos - ahora 26 colores únicos disponibles",
        "🐛 trip_id no se encontraba correctamente para consultar bolsas - ahora se obtiene desde múltiples fuentes",
        "🐛 Bolsas se duplicaban al tener múltiples en vivos del mismo viaje - ahora se suma solo una vez por viaje"
      ],
      technical: [
        "🔧 Función consolidateAccumulatedData convertida a async para obtener bolsas de abonos",
        "🔧 Obtención de bolsas por cliente+viaje con validación de duplicados",
        "🔧 Sistema de Set para tracking de viajes únicos por cliente",
        "🔧 Integración de apiService.advancePayment.getBalance en proceso de consolidación",
        "🔧 Cálculo de porcentaje de pago mejorado con validación de división por cero",
        "🔧 Asignación automática de tripId a envivos al cargar por viaje seleccionado"
      ]
    },
    highlights: [
      "💰 Integración completa de Bolsa de Abonos en Consolidado",
      "📊 Porcentaje de pago visible en todas las cards consolidadas",
      "🎨 Sistema ampliado de 26 colores para identificación de en vivos",
      "⚡ Carga secuencial optimizada con actualización progresiva de indicadores"
    ]
  },
  "2025-11-22T20:00:00.000Z": {
    version: "v2.3.0",
    date: "22 de Noviembre, 2025",
    changes: {
      new: [
        "🆕 Sistema de Abonos en Bolsa: Gestión de pagos anticipados por viaje para clientes",
        "🆕 Funcionalidad 'Viaja en Maleta': Marcar productos individuales como carry-on",
        "🆕 Cálculo dinámico de abono mínimo basado en productos en maleta (100% para maleta, 50% para normal)",
        "🆕 Búsqueda mejorada con resaltado visual en todas las páginas internas",
        "🆕 Indicador de saldo disponible en bolsa en modal de pagos",
        "🆕 Checkbox para enviar excedente de pago a bolsa de abonos",
        "🆕 Notificaciones cuando se usa abono automáticamente o se envía excedente a bolsa"
      ],
      improved: [
        "✨ Búsqueda expandible en iPad: botón con lupa que se expande a la izquierda",
        "✨ Botón 'Ir Arriba' siempre visible en todas las páginas internas",
        "✨ Modal de pagos mejorado: header y footer fijos, contenido con scroll",
        "✨ Menú secundario sticky que se pega al primer menú al hacer scroll",
        "✨ Cálculo automático de excedente de pago en tiempo real",
        "✨ Visualización mejorada de abono mínimo en cards de órdenes",
        "✨ Colores de botones de pago actualizados según abono mínimo calculado",
        "✨ Corrección de generación de imágenes html2canvas para evitar cortes de texto",
        "✨ Ícono de avión (✈️) en productos que viajan en maleta en vista Consolidado",
        "✨ Línea 'Abono Mín. (con maleta)' visible en cards consolidadas",
        "✨ Filtro de en vivos ahora muestra solo los del viaje seleccionado"
      ],
      fixed: [
        "🐛 Búsqueda no funcionaba en iPad - ahora resalta términos manualmente",
        "🐛 Modal de pagos empujaba botones fuera de vista con imágenes grandes",
        "🐛 html2canvas cortaba textos de productos y totales de cards",
        "🐛 Verificación de versión fallaba en desarrollo - ahora silenciado",
        "🐛 Checkbox 'Viaja en Maleta' desorganizaba productos en columnas",
        "🐛 Filtro de en vivos mostraba todos los en vivos sin filtrar por viaje seleccionado"
      ],
      technical: [
        "🔧 Nuevo servicio advancePaymentService para gestión de abonos en bolsa",
        "🔧 Endpoints: GET/POST /api/clients/:id/advance-payments, GET /api/clients/:id/advance-balance",
        "🔧 Campo send_excess_to_bag en uploadReceipt para envío automático de excedente",
        "🔧 Función calculatePaymentExcess para cálculo de excedente en tiempo real",
        "🔧 Función highlightText mejorada con TreeWalker para resaltado consistente",
        "🔧 useFrontendVersionCheck mejorado con manejo de errores en desarrollo",
        "🔧 Validación de min_payment consistente entre frontend y backend"
      ]
    },
    highlights: [
      "💼 Sistema completo de Abonos en Bolsa para gestión de pagos anticipados",
      "✈️ Funcionalidad 'Viaja en Maleta' con cálculo dinámico de abono mínimo",
      "🔍 Búsqueda mejorada con resaltado visual en todas las páginas",
      "📱 Mejoras de UI/UX para iPad con búsqueda expandible y menú sticky",
      "💰 Gestión inteligente de excedentes de pago con opción de bolsa"
    ]
  },
  "2025-01-14T00:00:00.000Z": {
    version: "v2.2.0",
    date: "14 de Enero, 2025",
    changes: {
      new: [
        "🆕 Campo 'Quick check' en tabla de búsqueda para marcar órdenes como revisadas rápidamente",
        "🆕 Integración de GPS en heartbeat con coordenadas de alta precisión",
        "🆕 Métricas de calidad de red en heartbeat (velocidad, latencia, tipo de conexión)"
      ],
      improved: [
        "✨ Tabla de búsqueda optimizada para mobile: columnas monetarias ocultas en dispositivos móviles",
        "✨ Columna 'Quick check' reubicada al extremo derecho de la tabla",
        "✨ Mejoras de UI responsive para iPad (menús, fuentes, espaciado)",
        "✨ Visualización mejorada con indicador verde cuando una orden está marcada como revisada"
      ],
      fixed: [
        "🐛 Corregido manejo de eventos mouseLeave en tooltips de pagos",
        "🐛 Actualización optimista de estado en toggle de quick_checked"
      ],
      technical: [
        "🔧 Integración de Geolocation API con enableHighAccuracy",
        "🔧 Network Information API para métricas de calidad de conexión",
        "🔧 Endpoint PUT /api/orders/:id/quick-check para gestión de revisión rápida",
        "🔧 Responsive design mejorado con clases hidden md:table-cell"
      ]
    },
    highlights: [
      "✅ Campo 'Quick check' para gestión rápida de revisión de órdenes",
      "📍 Geolocalización GPS integrada en heartbeat con alta precisión",
      "📊 Métricas de calidad de red en tiempo real",
      "📱 Tabla de búsqueda optimizada para dispositivos móviles"
    ]
  },
  "2025-10-26T19:15:00.000Z": {
    version: "v2.1.2",
    date: "26 de Octubre, 2025",
    changes: {
      new: [
        "🆕 Botón flotante 'Volver arriba' con scroll suave"
      ],
      improved: [
        "✨ Mejora en la carga de viajes en el componente Dashboard",
        "✨ Optimización de la carga inicial de datos",
        "✨ Navegación mejorada con botón de scroll rápido"
      ],
      fixed: [
        "🐛 Modal de creación de en vivo no mostraba viajes disponibles",
        "🐛 Dropdown de viajes vacío al intentar crear en vivo",
        "🐛 loadTrips no se ejecutaba en la carga inicial del Dashboard"
      ],
      technical: [
        "🔧 Agregado loadTrips() a useEffect de inicialización",
        "🔧 Carga de viajes antes de mostrar modal de creación",
        "🔧 Botón flotante con detección de scroll y animaciones"
      ]
    },
    highlights: [
      "🔧 Fix crítico: Modal de creación de envivo ahora funciona correctamente",
      "📋 Carga automática de viajes al iniciar Dashboard",
      "✅ Dropdown de viajes poblado correctamente",
      "⬆️ Botón flotante 'Volver arriba' para mejor navegación"
    ]
  },

  // Versión anterior
  "2025-10-26T16:45:00.000Z": {
    version: "v2.1.0",
    date: "26 de Octubre, 2025",
    changes: {
      new: [
        "🆕 Acordeones en Tablas de clientes y productos",
        "🆕 Reconocimiento de Voz para pedidos y productos",
        "🆕 Exportación a Excel con animación de carga",
        "🆕 Copiar imagen de orden al portapapeles",
        "🆕 Edición y eliminación de pagos existentes"
      ],
      improved: [
        "✨ Tablas colapsables para ahorrar espacio en pantalla",
        "✨ Visualización de KPIs mejorada en card del viaje",
        "✨ Información de pagos detallada con barras de progreso",
        "✨ Client ID en cards de orden",
        "✨ Indicadores financieros completos del viaje",
        "✨ Sistema de feature flags para logs"
      ],
      fixed: [
        "🐛 Error insertBefore en reconocimiento de voz",
        "🐛 Extracción de datos de API de clientes",
        "🐛 Filtrado de órdenes y productos por envivo",
        "🐛 Guion trailing en nombres de viajes",
        "🐛 Alineación de botones en cards de orden",
        "🐛 Cliente ID no mostrándose",
        "🐛 Carga de KPIs al seleccionar envivo",
        "🐛 Botón Exportar Excel no funcionando",
        "🐛 Tab Clientas vacío en Excel"
      ],
      technical: [
        "🔧 Sistema de refs para evitar re-renders innecesarios",
        "🔧 Timeout de silencio de 3 segundos en reconocimiento de voz",
        "🔧 hasBeenProcessedRef para evitar procesamiento duplicado",
        "🔧 Mejor manejo de estados asíncronos",
        "🔧 Sistema de logs condicionales por ambiente"
      ]
    },
    highlights: [
      "🎯 Tablas colapsables para mejor organización visual",
      "🎯 Reconocimiento de voz para crear pedidos y productos",
      "🎯 Exportación a Excel con reportes completos",
      "🎯 Copiar imágenes de órdenes para compartir en WhatsApp",
      "🎯 Gestión completa de pagos existentes"
    ]
  },

  // Versión base
  "2024-01-10T09:00:00.000Z": {
    version: "v1.0.0",
    date: "10 de Enero, 2024",
    changes: {
      new: [
        "🆕 Sistema de gestión de en vivos",
        "🆕 Gestión de clientes y productos",
        "🆕 Sistema de pedidos rápidos y manuales",
        "🆕 Reconocimiento de voz para pedidos",
        "🆕 Dashboard con KPIs y métricas"
      ],
      improved: [],
      fixed: [],
      technical: [
        "🔧 Arquitectura base de la aplicación",
        "🔧 Integración con API backend",
        "🔧 Sistema de autenticación"
      ]
    },
    highlights: [
      "🎯 Primera versión funcional de Makana Live Manager",
      "🎯 Todas las funcionalidades básicas implementadas"
    ]
  }
};

// Función para obtener los cambios de una versión específica
export const getVersionChanges = (version) => {
  return CHANGELOG[version] || null;
};

// Función para obtener los cambios de la versión más reciente
export const getLatestVersionChanges = () => {
  const versions = Object.keys(CHANGELOG).sort((a, b) => new Date(b) - new Date(a));
  return CHANGELOG[versions[0]] || null;
};

// Función para obtener todas las versiones disponibles
export const getAllVersions = () => {
  return Object.keys(CHANGELOG)
    .sort((a, b) => new Date(b) - new Date(a))
    .map(version => ({
      version,
      ...CHANGELOG[version]
    }));
};
